<script lang="ts">
	// Genuine shadcn-svelte Textarea (CLI-fetched), RESTYLED to price-check tokens.
	// `field-sizing-content` auto-grows to the content; min-h-16 is the floor.
	// NO arbitrary `[..]` values.
	import { cn, type WithElementRef, type WithoutChildren } from "../../../utils.js";
	import type { HTMLTextareaAttributes } from "svelte/elements";

	let {
		ref = $bindable(null),
		value = $bindable(),
		class: className,
		"data-slot": dataSlot = "textarea",
		...restProps
	}: WithoutChildren<WithElementRef<HTMLTextareaAttributes>> = $props();
</script>

<textarea
	bind:this={ref}
	data-slot={dataSlot}
	class={cn(
		"field-sizing-content flex min-h-16 w-full rounded-md border border-border bg-surface px-2.5 py-2 text-sm text-ink shadow-sm outline-none transition-colors placeholder:text-muted focus:border-brand focus:ring-2 focus:ring-brand disabled:cursor-default disabled:opacity-55",
		className
	)}
	bind:value
	{...restProps}
></textarea>
